/*
 *   File : profile.js
 *   Author : https://evoqins.com
 *   Description : User profile card
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

//Style
// import style from "../../Styles/Component/card.module.scss";w

// Assets
import { SecondaryButton, TextButton } from "../Buttons";
import { _formattedAmount } from "../../Helper";


function ProfileCard(props) {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const navigate = useNavigate();
    let brokers_info = USER_DATA.user_brokers_info && USER_DATA.user_brokers_info.length !== 0 ? USER_DATA.user_brokers_info : null;
    const selected_broker = brokers_info ? props.type === 2 ? brokers_info.find(broker => broker.client_code === props.brokerClientCode) : brokers_info.find(broker => broker.default === true) : null;

    return (
        props.type == 2 ?
            <div id="user-profile-card"
                className="d-flex flex-column justify-content-between p-3 w-100">
                <div className="d-flex justify-content-between mt-1">
                    <div className="d-flex flex-column gap-sm-2">
                        <span className="e-text-magnolia e-alt-font-lato e-font-weight-400 e-font-14 line-height-18px">
                            Wallet Balance
                        </span>
                        <span className="e-font-16-res e-primary-font-clash-display e-text-white e-font-weight-500 e-font-18 line-height-24px">
                            {_formattedAmount(Number(props.brokerAccountBalance) ? Number(props.brokerAccountBalance) : 0)}
                        </span>
                    </div>
                    {
                        selected_broker &&

                        <div className="d-flex align-items-center gap-1">
                            <img src={selected_broker.broker_logo}
                                className="object-fit-contain bg-white rounded-5 padding-2px-all"
                                alt="stock broker"
                                width={24}
                                height={24} />
                            <span className="mb-0 e-text-chinese-black  e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px">
                                {selected_broker.broker_name}
                            </span>
                        </div>
                    }
                </div>
                <div className="d-flex justify-content-between  gap-2">
                    <SecondaryButton name="Refresh"
                        fontSize="e-font-16"
                        padding="px-3 padding-10px-tb"
                        fontColor="e-text-primary-color"
                        className="mt-4"
                        onPress={props.handleUpdateBalance} />
                    {
                        props.navigate &&
                        <TextButton name="Change broker"
                            className="mt-auto"
                            labelClass="e-font-14-res-md"
                            iconClassName="w-16px-res"
                            icon={true}
                            type={3}
                            onPress={() => navigate("/account/connect-broker")} />
                    }
                </div>
            </div>
            :
            <div id="user-profile-card"
                className="d-flex flex-column justify-content-between p-3 w-100">
                <div className="d-flex justify-content-between mt-1">
                    <h6 className="e-font-16-res mb-0 e-text-white e-primary-font-clash-display e-font-weight-500 e-font-18 line-height-24px e-letter-spacing-1px ">
                        {/* Oswin Tucker */}
                        {USER_DATA.first_name} {USER_DATA.middle_name} {USER_DATA.last_name}
                    </h6>
                    {
                        selected_broker &&
                        <div className="d-flex align-items-center gap-1">
                            <img src={selected_broker.broker_logo}
                                className="object-fit-contain bg-white rounded-5 padding-2px-all"
                                alt="stock broker"
                                width={24}
                                height={24} />
                            <span className="e-font-14-res mb-0 e-text-chinese-black  e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px">
                                {selected_broker.broker_name}
                            </span>
                        </div>
                    }
                </div>
                <div className="d-flex justify-content-between gap-2">
                    <div className="d-flex flex-column gap-0">
                        <a href="tel:+919876543210" className="text-reset text-decoration-none">
                            <span className="e-text-white e-alt-font-lato e-font-weight-400 e-font-14 line-height-18px">
                                +91 {USER_DATA.mobile}
                            </span>
                        </a>
                        <a href="mailto:oswinbusiness@gmail.com" className="text-reset text-decoration-none">
                            <span className="e-text-white e-alt-font-lato e-font-weight-400 e-font-14 line-height-18px">
                                {USER_DATA.email}
                            </span>
                        </a>
                    </div>
                    {
                        props.navigate &&
                        <TextButton name="Change broker"
                            className="mt-auto"
                            labelClass="e-font-14-res"
                            iconClassName="w-16px-res"
                            icon={true}
                            type={3}
                            onPress={() => navigate("/account/connect-broker")} />
                    }
                </div>
            </div>
    )
}

export default ProfileCard;